import React, { useState, useEffect } from 'react'
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import SearchGrid from '../../components/table/SearchGrid'
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import DonationTotal from "./../../assets/img/icons/donationTotal.svg";
import DonationPending from "./../../assets/img/icons/donationPending.svg";
import DonationRejected from "./../../assets/img/icons/donationRejected.svg";
import DonationApproved from "./../../assets/img/icons/donationApproved.svg";

import { PostDataAPI } from '../../Services/APIService';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import Loader from "../../components/Loader/Loader";
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
//import AddProgram from './components/AddProgram';
//import ChangeDocument from './changeDocument/ChangeDocument';
import ClearIcon from '@material-ui/icons/Clear';
import PreviewDialog from "./preview/Preview";
import PrintIcon from './../../images/icons/PrintIcon.png';
import { formateMdnNumber, getFormatedDate, formatDate, formatDateTime } from '../../../src/components/Common/Extensions';
import { Table, TableRow, Collapse, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';
import { GetUserInfo } from '../../Services/GetUserInfo';
import Edit from './Edit/Edit';


function Applications({ applicationType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const [appProgram, setAppProgram] = useState(false);
    const [editRecordObj, setEditRecordObj] = useState({});
    const [changeDocumentAction, setChangeDocumentAction] = useState('');
    const [changeDocument, setChangeDocument] = useState(false)

    const [editRequest, setEditRequest] = useState(false);

    const [previewDialog, setPreviewDialog] = useState(false);
    const objLoggedInUser = JSON.parse(GetUserInfo())?.user;
    const [loggedInUserName] = useState(objLoggedInUser?.firstName + ' ' + objLoggedInUser.lastName);
    const OpenPreviewDialog = (item) => {
        setEditRecordObj(item);
        setPreviewDialog(true)
    }

    const ClosePreviewDialog = () => {
        setEditRecordObj({});
        setPreviewDialog(false);
    }
    const OpenChangeDocument = () => {
        setChangeDocument(true)
    }
    const OpenEditRequest = () => {
        setEditRecordObj({});
        setEditRequest(true)
    }
    const CloseChangeDocument = () => {
        setChangeDocument(false)
    }

    const editAttachments = (item) => {
        setEditRecordObj(item);
        setChangeDocument(true)
    }

    const editAppProgram = (item) => {
        setEditRecordObj(item);
        setEditRequest(true)
    }
    const addDelivery = (item) => {
        setEditRecordObj(item);
        setAppProgram(true)
    }
    const OpenAppProgram = () => {
        setEditRecordObj({});
        setAppProgram(true)
    }

    const CloseAppProgram = () => {
        setEditRecordObj({});
        setAppProgram(false)
    }
    const CloseEditRequest = () => {
        setEditRecordObj({});
        setEditRequest(false)
    }
    const AppProgramSuccessClose = (message) => {
        loadApplicationsGrid()
        showMessage("Success", message, "success", 3000);
        setAppProgram(false);
        CloseChangeDocument();
        setEditRecordObj({});
    }
    const EditRequestSuccessClose = (message) => {
        loadApplicationsGrid()
        showMessage("Success", message, "success", 3000);
        setEditRequest(false);
        //CloseChangeDocument();
        setEditRecordObj({});
    }


    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();

    };

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: ''
    });
    const [isLoading, setIsLoading] = useState(false);



    const applicationsStatusBoxes = [
        {
            value: 'Total',
            status: 'Total',
            numbers: '00',
            Icon: DonationTotal,
        },
        {
            value: 'Pending',
            status: 'Pending',
            numbers: '00',
            Icon: DonationPending,

        },
        {
            value: 'Rejected',
            status: 'Rejected',
            numbers: '00',
            Icon: DonationRejected,
        },
        {
            value: 'Approved',
            status: 'Approved',
            numbers: '00',
            Icon: DonationApproved,
        }


    ]

    const [applicationsData, setApplicationsData] = useState([]);

    const triggerMenu = (type) => {
        if (filteredApplicationsData && filteredApplicationsData.length > 0) {
            const applicationIds = filteredApplicationsData.map(item => item.applicationId);
            const postData = {
                applicationIds: applicationIds,
                type: type,
                applicationType: '',
                program:'ecc'
            };
            setIsLoading(true);
            PostDataAPI("everychildchristmas/exportApplications", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    if (type == 'print' || type == 'pdf') {
                        handlePrint(result.data);
                    } else {
                        window.open("." + result.data, "_blank")
                    }

                } else {

                }
            })
        } else {
            showMessage("Error", "No record exists", "error", 3000);
        }


    }
    const exportProgramAnalytics = () => {

        const postData = {
            type: 'analytics',
            applicationIds: [],
            applicationType: '',
            program: 'ecc'
        };
        setIsLoading(true);
        PostDataAPI("everychildchristmas/exportApplications", postData).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                window.open("." + result.data, "_blank");
            }
            else {
                showMessage("Error", "No record exists", "error", 3000);
            }
        })
    }


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;

        if (currValue.trim() === "" && currValue !== "") {
            return;
        }
        //    const trimedValue = currValue.trim()

        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const handleActionClick = (key, item) => {
        setPreviewDialog(false);
        switch (key) {

            case 'Approved':
                approveApplicationForm(item, key);
                break;
            case 'Rejected':
                rejectApplicationForm(item.applicationId, key);
                break;
            case 'preview':
                OpenPreviewDialog(item)
                break;
            case 'edit':
                editAppProgram(item);
                break;
            default:
                break;
        }

    }
    const lstOrlandoZipCodes = ["32808", "32809", "32805", "32811", "32839"];
    const approveApplicationForm = (item, key) => {
        showActionDialog('Are you sure you want to approve this application?', "confirm", function () {
            var isForOrlando = false;
            var eventLocation = "";
            var eventDate = "";
            var mapImage = "";
            var mapPath = "";
            if (lstOrlandoZipCodes.some(zip => zip == item.zip)) {
                isForOrlando = true;
                eventLocation = "2500 south kirkman rd Orlando FL 32811";
                eventDate = "Saturday December 23, 2023 from 9am-11am";
                mapImage = "\\Documents\\orlando_wallmart.png";
                mapPath = "https://maps.app.goo.gl/7g2XuvJvJtZuUFGy5";
            }

            var params = {
                applicationId: item.applicationId, Status: key, updatedByName: loggedInUserName,
                isForOrlando: isForOrlando, eventLocation: eventLocation, eventDate: eventDate,
                mapImage: mapImage, mapPath
            }
            setIsLoading(true);
            PostDataAPI("everychildchristmas/approve", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Application approved successfully", "success", 3000);
                    loadApplicationsGrid();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }

    const rejectApplicationForm = (applicationId, key) => {
        showActionDialog('Are you sure you want to reject this application?', "confirm", function () {
            var params = { applicationId: applicationId, Status: key, updatedByName: loggedInUserName }
            setIsLoading(true);
            PostDataAPI("everychildchristmas/reject", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Application rejected successfully", "success", 3000);
                    loadApplicationsGrid();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });

    }

    const handlePrint = (_htmlContent) => {
        // Create a new window or tab
        const newWindow = window.open('', '_blank');

        // Write your HTML content to the new window
        newWindow.document.open();
        newWindow.document.write(_htmlContent);
        newWindow.document.close();
    }

    const printApplicationForm = (item) => {
        setIsLoading(true)
        var params = { applicationId: item.applicationId };
        PostDataAPI("fdnmcchromicconnect/printApplication", params).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {

                handlePrint(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    };


    const [totalRecord, setTotalRecord] = useState();
    const [filteredApplicationsData, setFilteredApplicationsData] = useState();
    const [filteredStatus, setFilteredStatus] = useState(["Pending"]);

    const handleStatusClick = (event, status) => {
        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(status);
        }
        else {
            lstStatus = lstStatus.filter(s => s != status)
        }
        setFilteredStatus(lstStatus);
        if (lstStatus.length > 0) {
            if (status == 'Total') {
                setFilteredApplicationsData(applicationsData);
            } else {
                setFilteredApplicationsData(applicationsData.filter(o => lstStatus.some(s => s == o.status)));
            }
        }
        else {
            setFilteredApplicationsData(applicationsData);
        }

        handleDataGridUpdate();
    }

    const topActions = [
        { key: 'print', label: 'Print' },
        { key: 'csv', label: 'CSV' },
        { key: 'excel', label: 'Excel' }
    ];

    const loadApplicationsGrid = () => {

        setIsLoading(true);
        //var param = [filter ? filter : filters.salesFilter];
        PostDataAPI("everychildchristmas/loadGrid").then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                console.log(result.data)
                setTotalRecord(result.data)
                //const filteredItems = result.data.filter(item => item.status == (applicationType == 'requests'?'Applied':'Delivered' ));
                getDistinctApplicationCountByCity(result.data);
                var record = result.data.map((item, i) => {
                    item.confirmationCode = "F-" + item.applicationId;
                    item.phone = formateMdnNumber(item.phone);
                    //item.email = item.email;
                    item.completeAddress = item.address + " " + item.city + ', ' + item.state + ' ' + item.zip;
                    item.applicationStatus = item.status;

                    return { ...item };
                })
                setApplicationsData(record);
                setFilteredApplicationsData(record.filter(item => item.status == 'Pending'));
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }


    const deleteApplicationForm = (applicationId) => {
        showActionDialog("Are you sure you want to delete this record?", "confirm", function () {
            var params = { applicationId: applicationId }
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/delete", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Record deleted successfully", "success", 3000);
                    loadApplicationsGrid();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }

    const getRequestStatusCount = (status) => {
        var count = 0;
        if (status == 'Total') {
            count = totalRecord?.length
        }
        else if (status == 'Pending') {
            count = totalRecord?.filter(t => t.status == 'Pending' || t.status == 'Applied').length
        } else if (status == 'Rejected') {
            count = totalRecord?.filter(t => t.status == 'Rejected').length
        }
        else if (status == 'Approved') {
            count = totalRecord?.filter(t => t.status == 'Approved').length
        }
        return count;
    }
    const [applicationsCount, setApplicationsCount] = useState({});
    const getDistinctApplicationCountByCity = (record) => {
        const objApplicationsCount = {};
        record.forEach(item => {
            let appCity = 'Other'; //item.region;
            if (lstOrlandoZipCodes.some(zip => zip == item.zip)) {
                appCity = 'Orlando';
            }
            else {
                appCity = 'Fort Lauderdale/Lauderhill';
            }
            objApplicationsCount[appCity] = (objApplicationsCount[appCity] || 0) + 1;
        });
        setApplicationsCount(objApplicationsCount);
    }
    useEffect(() => {
        loadApplicationsGrid();
    }, [applicationType]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Every Child Christmas"} isBack={false} currentLink={'Applications'}></Breadcrums>
                    </Grid>
                </Grid>

            </div>



            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {applicationsStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.status) }}
                                        checked={filteredStatus.filter(value => value === item.status).length > 0 ? true : false}
                                    />
                                }
                                label={<>
                                    <div className={item.status == "Total" ? classes.statusBoxes + " " + "Total" :
                                        item.status == "Pending" ? classes.statusBoxes + " " + "Pending" :
                                            item.status == "Rejected" ? classes.statusBoxes + " " + "Rejected" :
                                                item.status == "Approved" ? classes.statusBoxes + " " + "Approved" : ''

                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <span style={{
                                                fontSize: '35px',
                                                color: 'white'
                                            }} >
                                                {getRequestStatusCount(item.status)} </span>
                                            <h3>{item.value}

                                            </h3>
                                        </div>
                                        <img src={item.Icon} />

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>
                <div className={classes.labelBullet}>

                    {Object.entries(applicationsCount).map(([appCount, count]) => (
                        <li key={appCount}>
                            {!appCount ? 'Other' : appCount}: {count}
                        </li>
                    ))}

                </div>
                <Button className={classes.changeBtn} onClick={loadApplicationsGrid}>Refresh</Button>
                <Button className={classes.changeBtn} onClick={exportProgramAnalytics}>Export Analytics</Button>
                <div className={classes.gridActions}>

                    <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                topActions.map((menuItem, index) => {
                                    return <Menu.Item

                                        key={menuItem.key}
                                        onClick={() => triggerMenu(menuItem.key)}
                                    > <img src={menuItem.icon} /> {menuItem.label}
                                    </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn}>
                                Export <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    <Button className={classes.changeBtn} onClick={OpenEditRequest}>Application Form</Button>

                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                    />

                </div>





            </Grid>

            <Grid row className={classes.container} >
                <SearchGrid columns={"EveryChildChristmas"}
                    list={filteredApplicationsData}
                    noRecordMsg="No record exists."
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    onActionClick={handleActionClick}
                    isTopPagination={true}
                />
            </Grid>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {appProgram ? ''
                //<AddProgram
                //    dialogOpenClose={OpenAppProgram}
                //    handleClose={CloseAppProgram}
                //    handleSuccessClose={AppProgramSuccessClose}
                //    record={editRecordObj}
                //></AddProgram>
                : ''}

            {changeDocument ? ''
                //<ChangeDocument
                //    dialogOpenClose={OpenChangeDocument}
                //    handleClose={CloseChangeDocument}
                //    handleSuccessClose={AppProgramSuccessClose}
                //    record={editRecordObj}
                //    changeDocumentAction={changeDocumentAction}
                //></ChangeDocument>
                : ''
            }
            {editRequest ?
                <Edit
                    dialogOpenClose={OpenEditRequest}
                    handleClose={CloseEditRequest}
                    handleSuccessClose={EditRequestSuccessClose}
                    record={editRecordObj}
                ></Edit>
                : ''}
            {previewDialog ?
                <PreviewDialog
                    dialogOpenClose={OpenPreviewDialog}
                    handleClose={ClosePreviewDialog}
                    record={editRecordObj}
                >
                </PreviewDialog>
                : ''}
        </>
    )

}

export default withSnackbar(Applications);